// Mirrors backend `CardStatsResponseDto`; keep in sync.
export const CARD_STATS_RANGES = ["7d", "30d", "90d", "mtd", "ytd"] as const;
export type CardStatsRange = (typeof CARD_STATS_RANGES)[number];

export interface CardStatsPeriod {
  range: CardStatsRange;
  from: string;
  to: string;
  days: number;
  bucket: "day" | "week" | "month";
}

export interface CardStatsFlow {
  amount: number;
  count: number;
}

export interface CardStatsBucket {
  label: string;
  amount: number;
  date: string;
}

export interface CardStatsMerchant {
  name: string;
  category: string | null;
  amount: number;
  share: number;
  count: number;
}

export interface CardStatsResponse {
  period: CardStatsPeriod;
  available_balance: number;
  loaded: CardStatsFlow;
  spent: CardStatsFlow;
  net: number;
  avg_ticket: number;
  declined_count: number;
  unique_merchants: number;
  spend_series: CardStatsBucket[];
  top_merchants: CardStatsMerchant[];
}
